import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import DetailsList from './DetailsList';
import ApiClient from '../../utilities/apiClient';
import AppConfig from '../../AppConfig';
import dayjs from 'dayjs';
import { useAppData } from '../../redux/appDataProvider';
import exportFromJSON from 'export-from-json';
var arrToObj = require('array-to-object')

const DetailsListController = () => {
  const [ledgerDetailsData, setLedgerDetailsData] = useState([]);
  const apiToken = useSelector(state => state.auth.apiToken);
  const userId = useSelector(state => state.auth.userId);
  const [fromDate, setFromDate] = useState(new Date().toLocaleDateString()); // Initialize with current date or another valid date
  const [toDate, setToDate] = useState(new Date().toLocaleDateString()); // Initialize with current date or another valid date
  const fromDateRef = useRef(fromDate);
  const toDateRef = useRef(toDate);
  const { selectedYear, setSelectedYear } = useAppData();
  const [showmodal, setShowModal] = React.useState(false);
  const [showlodder, setShowLodder] = React.useState(false);
// removed unnecessary code -30-07-24 - Dev Srini
  const handleFromDateChange = (date) => {
    if(!date) return
    fromDateRef.current = dayjs(date).format("DD/MM/YYYY") // amended format -30-07-24 - Dev Srini
  };

  const handleToDateChange = (date) => {
    if(!date) return
    toDateRef.current = dayjs(date).format("DD/MM/YYYY");// Amended fromat -30-07-24 - Dev Srini
  };
  
  const handleSubmit = () => {
    // Call fetchData with the selected fromDate and toDate
    fetchData();
  };
  const downloadFile = (content, filename, contentType) => {
    const blob = new Blob([content], { type: contentType });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
  };
  const handleDownload = async () => {
    try {
      const apiClient = new ApiClient(apiToken);

      apiClient.fetchData(
        AppConfig.api.Ledger.download,
        "POST",
        {
          cl: userId,
          toDt: toDateRef.current,
          frDt: fromDateRef.current,
          grp: "GRP1",
          type: AppConfig.downloadTypes.JSON,
        }
      )
        .then((response) => {
          console.log("response ✅", response);

          if (response === 401) {
            setShowModal(true);
            return;
          }

          if (!response || response.Success !== "True") return;

          const successDesc = response["Success Description"];
          const ledgerRows = successDesc?.data;

          if (!Array.isArray(ledgerRows) || ledgerRows.length === 0) return;

          // ✅ Transform API data → CSV rows
          const csvData = ledgerRows.map((r) => {
            const debit = Number(r.DR_AMT || 0);
            const credit = Number(r.CR_AMT || 0);
            const bal = Number(r.CLOSING_AMT || 0);

            return {
              "Date": r.VoucherDate1 || "",
              "V.No": r.VOUCHERNO || "",
              "Particulars": `${r.TRADING_COCD || r.COCD || ""} ${r.NARRATION || ""}`.trim(),
              "ChqNo.": r.ChqNo1 || r.CHQNO || "0.00",
              "Debit": debit ? debit.toFixed(2) : "0.00",
              "Credit": credit ? credit.toFixed(2) : "0.00",
              "Balance": `${Math.abs(bal).toFixed(2)} ${bal >= 0 ? "Cr" : "Dr"}`
            };
          });

          // ✅ CSV Export
          exportFromJSON({
            data: csvData,
            fileName: "Ledger",
            exportType: exportFromJSON.types.csv,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error("Error fetching ledger:", error);
    }
  };

  const handlePDFDownload = async () => {
    try {
      const apiClient = new ApiClient(apiToken);

      apiClient.fetchData(
        AppConfig.api.Ledger.downloadPDF,
        "POST",
        {
          cl: userId,
          toDt: toDateRef.current,
          frDt: fromDateRef.current,
          grp: "GRP1",
          type: AppConfig.downloadTypes.JSON,
        }
      )
        .then((response) => {
          console.log("response ✅", response);

         
          if (!response || response.status === 500) {
            window.alert("No PDF data found between the selected dates.");
            return
          }


          // ✅ Base64 string
          const base64PDF = response

          // ✅ Decode Base64 → binary
          const binaryString = window.atob(base64PDF);
          const len = binaryString.length;
          const bytes = new Uint8Array(len);

          for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }

          const filename = AppConfig.getFormattedDate(
            "Ledger_",
            AppConfig.downloadTypes.PDF
          );

          downloadFile(bytes, filename, "application/pdf");
        })
        .catch((error) => {
          console.log("PDF download error:", error);
        });
    } catch (error) {
      console.log("Error fetching ledger PDF:", error);
    }
  };


  
  // Simulate fetching data from an API or some other source
  const fetchData = async () => {

    
    try {
      // Replace this with your actual data fetching logic
      // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMTM1MTIxNywiZXhwIjoxNzExMzUzMDE3fQ.W6yAyoTXBefesvAMWN-2MuxVlS1d33l7d_ZGIKUMDcU";
      setShowLodder(true)
      const apiClient = new ApiClient(apiToken);
// removed unnecessary code -30-07-24 - Dev Srini
      
      apiClient.fetchData(
        AppConfig.api.Ledger.details,
        "POST",
        {
          "Client_code": userId,
          "FromDate": fromDateRef.current,// dayjs(fromDateRef.current).format('DD/MM/YYYY'),
          "ToDate": toDateRef.current , //dayjs(toDate).format('DD/MM/YYYY'),
          "COCDLIST": "ALL",
          "ShowMargin": "Y", 
          "ShowAllData": "Y",
          "Merge_Company": "Y"
        })
        .then((response) => {
          console.log("responseeeeeeeeeeeeeeeeeeeeeeeeee",response)
// removed unnecessary code -30-07-24 - Dev Srini
          setShowLodder(false)
          if(response.Success == "False"){ 
            setLedgerDetailsData([])
          }
          if(response===401){setShowModal(true)}
          if(response && response.Success == "True" && response.hasOwnProperty("Success Description")){
            let responseData = response["Success Description"]; 

            console.log("Success Description",responseData)
            // removed unnecessary code -30-07-24 - Dev Srini
            if (Array.isArray(responseData) && responseData.length > 0) {
              // Sorting - 23-07-24 - Dev Srini
              const sortedData = responseData.sort((a, b) => {
                const dateA = new Date(a.PUNCH_TIME)
                const dateB = new Date(b.PUNCH_TIME)

                return dateB - dateA
              })


              setLedgerDetailsData(sortedData);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  };
  const setFromDateToDate = async() => {
    const currentDate = new Date();
    const currentYear = selectedYear.Database_Year//currentDate.getFullYear();
    

    let financialYearStart, financialYearEnd;
    let aa=0
    aa= parseInt( currentYear)+1
    financialYearStart="01/04/"+currentYear
    financialYearEnd="30/03/"+aa

    /*if (currentDate.getMonth() < 3) { 
        financialYearStart = new Date(currentYear - 1, 3, 1).toLocaleDateString(); 
    } else {
        financialYearStart = new Date(currentYear, 3, 1).toLocaleDateString(); 
    }
    // Calculate financial year end date
    if (currentDate.getMonth() < 3) {
        financialYearEnd = new Date(currentYear, 2, 31).toLocaleDateString(); 
    } else {
        financialYearEnd = new Date(currentYear + 1, 2, 31).toLocaleDateString();
    }*/
   let fd= financialYearStart.split("/").reverse().join("-");
   let td= financialYearEnd.split("/").reverse().join("-");

    setFromDate(fd);
    setToDate(td);
    fromDateRef.current = financialYearStart;
    toDateRef.current = financialYearEnd;
    
    fetchData();
  };

  useEffect(() => {
    setFromDateToDate();
  }, [selectedYear.Database_Year]); // Empty dependency array to fetch data only once on component mount

  return <DetailsList 
    data={ledgerDetailsData} 
    fromDate={fromDate} 
    toDate={toDate} 
    handleSubmit={handleSubmit} 
    handleDownload={handleDownload} 
    handlePDFDownload={handlePDFDownload} 
    showmodal={showmodal}
    showlodder={showlodder}
    // code optimized -30-07-24 - Dev Srini
    handleFromDateChange={handleFromDateChange}
    handleToDateChange={handleToDateChange}
    startYear = {selectedYear.Database_Year}
    endYear = {(parseInt(selectedYear.Database_Year) + 1).toString()}
    />;
};

export default DetailsListController;
